module.exports = __webpack_public_path__ + "static/media/logo-xpdconnect-azul.4f3f43dd.svg";